import { useHistory } from "react-router-dom";
import { ActionType, BusinessType } from "../models/Enums";
import Api from "../utils/api-interceptor";

export const LoginAuth = async (obj: any) => {
  //  //;
  // console.log(obj);
  //console.log("going to execute PostAttendAlert with", JSON.stringify(obj));
  return Api.post("Auth/Login", obj).then(
    (response) => {
      //   //;
      return response;
    },
    (error) => {
      //console.log("Error:", error);
      debugger;
    },
  );
};

// export const GetMobileUIVersion = async () => {
//   return Api.get("Auth/GetMobileUiVersion")
//     .then((response) => {
//       if (localStorage.getItem("mobileUiVersion") != null && localStorage.getItem("mobileUiVersion") !== undefined) {
//         if (localStorage.getItem("mobileUiVersion") !== response.data.toString()) {
//           localStorage.setItem("mobileUiVersion", response.data.toString())
//           window.location.reload();
//         }
//       }
//       else {
//         localStorage.setItem("mobileUiVersion", response.data.mobileUiVersion)
//         window.location.reload();
//       }
//     });
// }

//export const RegisterPatientAuth = async (obj: PatientVM) => {
export const RegisterPatientAuth = async (obj: any) => {
  return Api.post("Patient/RegisterPatient", obj).then(
    (response) => {
      return response;
    },
    (error) => {
      console.log("Error:", error);
    },
  );
};
export const GetUserById = async (obj: any) => {
  return Api.post("Common/GetUserByID", obj).then(
    (response) => {
      //;
      return response;
    },
    (error) => {
      //console.log("Error:", error);
    },
  );
};

export const GetUserByEmail = async (obj: any) => {
  return Api.post("Auth/GetUserByEmailAddressforSignUp", obj).then(
    (response) => {
      return response;
    },
    (error) => {},
  );
};

export const GetGeneralLookupData = async (obj: any) => {
  return Api.post("Lookups/GetDataAsGeneralLookup", obj).then(
    (response) => {
      //;
      return response;
    },
    (error) => {
      //console.log("Error:", error);
    },
  );
};
export const GetPatientAssessmentAndLookups = async (obj: any) => {
  return Api.post("Lookups/GetPatientAssessmentAndLookups", obj).then(
    (response) => {
      //;
      return response;
    },
    (error) => {
      //console.log("Error:", error);
    },
  );
};
export const GetRefreshToken = async (obj: any) => {
  return Api.post("Auth/RefreshToken/refresh-token", obj).then(
    (response) => {
      return response;
    },
    (error) => {
      //console.log("Error:", error);
    },
  );
};

export const AddUpdateLookups = async (obj: any, url: string | undefined) => {
  // console.log("obj",obj)
  // return Api.post("Lookups/AddUpdateTag", obj)
  return Api.post(url!, obj).then(
    (response) => {
      //;
      return response;
    },
    (error) => {
      //console.log("Error:", error);
    },
  );
};

export const EditUserAuth = async (obj: any) => {
  return Api.post("Clinician/UpdateUser", obj).then(
    (response) => {
      //;
      return response;
    },
    (error) => {},
  );
};
export const ForgotPasswordAuth = async (obj: any) => {
  console.log("API: ", Api);
  return Api.post("PasswordRecovery/SavePasswordRecoveryToken", obj).then(
    (response) => {
      return response;
    },
    (error) => {},
  );
};

export const OTPAuth = async (obj: any) => {
  return Api.post("PasswordRecovery/ValidatePasswordCode", obj).then(
    (response) => {
      return response;
    },
    (error) => {},
  );
};
export const OTPCodeSignupAuth = async (obj: any) => {
  return Api.post("Auth/ValidateOtpCode", obj).then(
    (response) => {
      return response;
    },
    (error) => {},
  );
};

export const RegisterUserAuth = async (obj: any) => {
  return Api.post("Auth/RegisterUser", obj).then(
    (response) => {
      return response;
    },
    (error) => {},
  );
};
export const SetPasswordAuth = async (obj: any) => {
  return Api.post("PasswordRecovery/SaveUserPassword", obj).then(
    (response) => {
      return response;
    },
    (error) => {},
  );
};
export const UpdatePasswordFromProfile = async (obj: any) => {
  return Api.post("Clinician/UpdateUserPassword", obj).then(
    (response) => {
      return response;
    },
    (error) => {},
  );
};

export const SearchPatientAuth = async (obj: any) => {
  // //;
  //console.log(obj);
  return Api.post("Patient/SearchPatient", obj).then(
    (response) => {
      return response;
    },
    (error) => {
      //console.log("Error:", error);
    },
  );
};

export const SearchIntegrationPatientAuth = async (obj: any) => {
  return Api.post("IntegrationPatient/Search", obj).then(
    (response) => {
      return response;
    },
    (error) => {},
  );
};

export const ImportIntegrationPatientAuth = async (obj: any) => {
  return Api.post("IntegrationPatient/Import", obj).then(
    (response) => {
      return response;
    },
    (error) => {},
  );
};

export const GetPatientById = async (obj: any) => {
  return Api.post("Patient/GetPatientById", obj).then(
    (response) => {
      return response;
    },
    (error) => {},
  );
};
export const GetTrendlineGraph = async (obj: any) => {
  debugger;
  return Api.post("Patient/GetTrendLineGraphs", obj).then(
    (response) => {
      return response;
    },
    (error) => {},
  );
};
export const AddUpdateMobileWorkstationPatient = async (obj: any) => {
  debugger;
  return Api.post("Patient/AddUpdateMobileWorkstationPatient", obj).then(
    (response) => {
      return response;
    },
    (error) => {},
  );
};
export const GetRecentSearchesAuth = async (obj: any) => {
  return Api.post("Patient/GetRecentSearches", obj).then(
    (response) => {
      return response;
    },
    (error) => {},
  );
};
export const SaveRecentSearchAuth = async (obj: any) => {
  return Api.post("Patient/SaveRecentSearch", obj).then(
    (response) => {
      return response;
    },
    (error) => {},
  );
};

export const LogOut = async () => {
  debugger;
  //let history = useHistory();
  const token = localStorage.getItem("TokenID");
  const obj: any = {
    BusinessType: BusinessType.Cloud,
    Token: token,
    LogoutTime: new Date(),
  };
  return Api.post("Auth/Logout", obj).then(
    (response) => {
      debugger;
      if (response && response!.data.responseCode !== 0) {
        let UiVersion = localStorage.getItem("mobileUiVersion");
        let getAssessmentHisotory = JSON.parse(
          localStorage.getItem("summaryDetail") || "[]",
        );
        let userEmail = JSON.parse(
          localStorage.getItem("loggedInUserName") || "[]",
        );
        localStorage.clear();
        localStorage.setItem(
          "summaryDetail",
          JSON.stringify(getAssessmentHisotory!),
        );
        localStorage.setItem("mobileUiVersion", UiVersion!);
        localStorage.setItem(
          "loggedInUserName",
          JSON.stringify({ email: userEmail.email! }),
        );
        //localStorage.setItem("mobileUiVersion", UiVersion!);
        //  history.push("/login");
        // window.location.reload();
        return response;
      }
    },
    (error) => {
      debugger;

      // if(error.response.status === 401) {
      //   //localStorage.clear();
      //   window.location.href = window.location.origin + "/login";
      // }
      //  history.push("/confirmation", { actionType: ActionType.FailureAPIResponse });
      console.log("Error:", error);
      return error;
    },
  );
};

export const GetAssessmentMetricsLookup = async (obj: any) => {
  return Api.post("Lookups/GetAssessmentMetrics", obj).then(
    (response) => {
      return response;
    },
    (error) => {},
  );
};

export const GenerateJsonToken = async (obj: any) => {
  return Api.post("Auth/GenerateJsonToken", obj).then(
    (response) => {
      return response;
    },
    (error) => {},
  );
};

export const SaveConsentForm = async (obj: any) => {
  return Api.post("Patient/SaveConsentForm", obj).then(
    (response) => {
      return response;
    },
    (error) => {},
  );
};

export const EnableDisablePatientRtm = async (obj: any) => {
  return Api.post("Patient/EnableDisablePatientRtm", obj).then(
    (response: any) => {
      console.log("RTM Status Update Response:", response);
      console.log("RTM Start Date:", response?.data?.eligibility?.rtmDate);
      if (obj.IsPatientRTMEnabled && response?.data?.eligibility) {
        const startDate = new Date(response?.data?.eligibility?.rtmDate);
        const billingRequest = {
          MasterUserId: response.data.eligibility.masterUserid,
          RtmDate: response?.data?.eligibility?.rtmDate,
          RtmMonth: startDate.getMonth() + 1,
          CptCode: "98975",
          SelectedBusinessTypeFrontEnd: localStorage.getItem("businessType")!,
          LocationMasterEpisodeId:
            response.data.eligibility.locationMasterEpisodeId,
          IsCpt98975Billable: response.data.eligibility.isCpt98975Billable,
          IsCpt98975Display: response.data.eligibility.isCpt98975Display,
          IsPyLogin: response.data.eligibility.isPyLogin,
          CalanderMonthEpisodeId:
            response.data.eligibility.calanderMonthEpisodeId,
        };

        console.log("Creating RTM Billing Record:", billingRequest);

        Api.post("Patient/SavePatientRtmBilling", billingRequest).then(
          (billingRes) => console.log("RTM Billing Created:", billingRes),
          (err) => console.error("Error creating RTM Billing:", err),
        );
      }
      return response;
    },
    (error) => {
      console.log("Error:", error);
    },
  );
};

export const SaveEducationProvided = async (obj: any) => {
  return Api.post("Patient/SaveEducationProvided", obj).then(
    (response) => {
      return response;
    },
    (error) => {},
  );
};
export const SaveSetUpEpisode = async (obj: any) => {
  return Api.post("Patient/SaveSetUpEpisode", obj).then(
    (response) => {
      return response;
    },
    (error) => {},
  );
};
export const GetLatestSetUpEpisode = async (obj: any) => {
  return Api.post("Patient/GetLatestEpisode", obj).then(
    (response) => {
      return response;
    },
    (error) => {},
  );
};
export const ValidateEmailAndPhoneNum = async (obj: any) => {
  return Api.post("Patient/ValidateEmailAndPhoneNum", obj).then(
    (response) => {
      return response;
    },
    (error) => {},
  );
};
export const getRTMEpisodes = async () => {
  return Api.post("Lookups/GetRTMEpisodes", {}).then(
    (response) => {
      return response;
    },
    (error) => {},
  );
};
export const GenerateLinkForQRCode = async (request: any) => {
  return Api.post("Patient/GenerateLinkForQRCode", request).then(
    (response) => {
      return response;
    },
    (error) => {
      console.error("Error:", error);
    },
  );
};
export const CreatePatientOnProactiveYou = async (request: any) => {
  return Api.post("Patient/CreatePatientOnProactiveYou", request).then(
    (response) => {
      return response;
    },
    (error) => {
      console.error("Error:", error);
    },
  );
};

export const GetRtmPatientEducationStatus = async (request: any) => {
  return Api.post("Patient/GetRtmPatientEducationStatus", request).then(
    (response) => {
      return response;
    },
    (error) => {
      console.error("Error:", error);
    },
  );
};
